<template>
  <div class="col-sm-12 col-md-6 col-lg-7 mb-3 mb-md-0 w1">
    <div class="card h-100">
      <div class="card-header">
        <h2>Customer</h2>
      </div>
      <hr width="95%" class="my-0 ml-3" />
      <div class="card-body mb--20" v-if="customer">
        <div class="row">
          <div id="customerInfo" v-if="customer" class="col-12 col-sm-10">
            <div class="row">
              <div class="col-6">
                <p class="d-inline-block font-weight-bold">Customer Reference:</p>
              </div>
              <div class="col-6">
                <a class="pointer" v-clipboard:copy="customer.CustomerReference" v-clipboard:success="onCopy"
                  v-clipboard:error="onError">
                  <p class="d-inline-block">{{ customer.CustomerReference }}</p>
                </a>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <p class="d-inline-block font-weight-bold">Customer Name:</p>
              </div>
              <div class="col-6">
                <p class="d-inline-block">{{ customer.CustomerName }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <p class="d-inline-block font-weight-bold">Account Status:</p>
              </div>
              <div class="col-6">
                <b-badge v-if="customer.IsBillable" class="pill my-auto" variant="success">Active</b-badge>
                <b-badge v-else class="pill my-auto" variant="secondary">Inactive</b-badge>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-2 text-sm-center mt--20 mobile-space-t mobile-space-b"
            v-if="customer.Contacts.length != 0">
            <div class="d-flex flex-row justify-content-center align-items-center h-100">
              <img v-if="fallbackImage || !(customer.BillingContact && customer.BillingContact.Email)"
                src="../../../src/assets/img/logo_unavailable.png" class="pr-3" alt="Fallback Image" />
              <img v-else :src="'//logo.clearbit.com/' + customer.BillingContact.Email.split('@')[1] + '?size=70'"
                class="pr-3" alt="Logo unavailable" @error="setFallbackImageUrl" />
            </div>
          </div>
        </div>
        <hr />
        <!-- Billing and primary address and bill delivery method and collection methods start -->
        <div v-if="customer.Contacts.length != 0">
          <div class="row">
            <div class="container-fluid">
              <div class="row">
                <div v-if="customer" class="col-sm-7 col-md-12 col-lg-7 col-xl-6">
                  <nav>
                    <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
                      <a class="nav-item nav-link active" id="nav-cust-billing-info-tab" data-toggle="tab"
                        href="#nav-cust-billing-info" role="tab" aria-controls="nav-cust-billing-info"
                        aria-selected="true">Billing</a>
                      <a class="nav-item nav-link" id="nav-cust-primary-info-tab" data-toggle="tab"
                        href="#nav-cust-primary-info" role="tab" aria-controls="nav-cust-primary-info"
                        aria-selected="false">Primary</a>
                    </div>
                  </nav>
                  <div class="tab-content mt-3" id="nav-tabContent">
                    <div class="tab-pane fade show active" id="nav-cust-billing-info" role="tabpanel"
                      aria-labelledby="nav-cust-billing-info-tab">
                      <!-- Billing -->
                      <div class="col-12 no-pad">
                        <div class="row">
                          <div class="col-4">
                            <p class="font-weight-bold mb-0">Name</p>
                          </div>
                          <div class="col-sm-8">
                            <ul class="list-group">
                              <li class="list-group-item">
                                <div class="d-inline" v-if="customer.BillingContact.hasOwnProperty('Title')">
                                  {{ customer.BillingContact.Title + ' ' }}
                                </div>
                                <div class="d-inline" v-if="customer.BillingContact.hasOwnProperty('FirstName')">
                                  {{ customer.BillingContact.FirstName + ' ' }}
                                </div>
                                <div class="d-inline" v-if="customer.BillingContact.hasOwnProperty('Lastname')">
                                  {{ customer.BillingContact.Lastname }}
                                </div>
                              </li>
                            </ul>
                          </div>
                          <div class="col-4">
                            <p class="font-weight-bold mt-3 mt-sm-2 mb-0">Address</p>
                          </div>
                          <div class="col-sm-8 mt-sm-2">
                            <ul class="list-group">
                              <li class="list-group-item"
                                v-for="(line, index) in customer.BillingContact.Address.AddressLines" :key="index">
                                {{ line }}
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="row mt-3">
                          <div class="col-4">
                            <p class="font-weight-bold">Tel</p>
                          </div>
                          <div class="col-8">
                            <ul class="list-group">
                              <li class="list-group-item">{{ formatTelephoneNumber(customer.BillingContact.Landline) }}
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="row mt--20">
                          <div class="col-4">
                            <p class="font-weight-bold">Email</p>
                          </div>
                          <div class="col-8">
                            <ul class="list-group">
                              <li class="list-group-item">
                                <a class="text-lowercase underline" :href="'mailto:' + customer.BillingContact.Email">{{
                                  customer.BillingContact.Email
                                }}</a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane fade" id="nav-cust-primary-info" role="tabpanel"
                      aria-labelledby="nav-cust-primary-info-tab">
                      <!-- primary new -->
                      <div class="col-12 no-pad">
                        <div class="row">
                          <div class="col-4">
                            <p class="font-weight-bold mb-0">Name</p>
                          </div>
                          <div class="col-sm-8">
                            <ul class="list-group">
                              <li class="list-group-item">
                                <div class="d-inline" v-if="customer.PrimaryContact.hasOwnProperty('Title')">
                                  {{ customer.PrimaryContact.Title + ' ' }}
                                </div>
                                <div class="d-inline" v-if="customer.PrimaryContact.hasOwnProperty('FirstName')">
                                  {{ customer.PrimaryContact.FirstName + ' ' }}
                                </div>
                                <div class="d-inline" v-if="customer.PrimaryContact.hasOwnProperty('Lastname')">
                                  {{ customer.PrimaryContact.Lastname }}
                                </div>
                              </li>
                            </ul>
                          </div>
                          <div class="col-4">
                            <p class="font-weight-bold mt-3 mt-sm-2 mb-0">Address</p>
                          </div>
                          <div class="col-sm-8 mt-sm-2">
                            <ul class="list-group">
                              <li class="list-group-item"
                                v-for="(line, index) in customer.PrimaryContact.Address.AddressLines" :key="index">
                                {{ line }}
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="row mt-3">
                          <div class="col-4">
                            <p class="font-weight-bold">Tel</p>
                          </div>
                          <div class="col-8">
                            <ul class="list-group">
                              <li class="list-group-item">{{ formatTelephoneNumber(customer.PrimaryContact.Landline) }}
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="row mt--20">
                          <div class="col-4">
                            <p class="font-weight-bold">Email</p>
                          </div>
                          <div class="col-8">
                            <ul class="list-group">
                              <li class="list-group-item">
                                <a class="text-lowercase underline" :href="'mailto:' + customer.PrimaryContact.Email">{{
                                  customer.PrimaryContact.Email
                                }}</a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-5 col-md-12 col-lg-5 col-xl-6">
                  <!-- bill delivery method start -->

                  <div id="billDeliveryMethods" class="row">
                    <div class="col-12">
                      <p class="font-weight-bold d-inline">Bill Delivery Methods</p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6 col-sm-12 col-md-6">
                      <b-form-radio-group v-model="billDeliveryMethod">
                        <div class="row">
                          <div class="col">
                            <b-form-radio class="ml-2 mb-2" name="Email" value="Email">Email</b-form-radio>
                          </div>
                          <div class="col">
                            <b-form-radio class="ml-2 mb-2" name="Post" value="Post">Post</b-form-radio>
                          </div>
                          <div class="col">
                            <b-form-radio class="ml-2 mb-2" name="Manual" value="Manual">Manual</b-form-radio>
                          </div>
                        </div>
                      </b-form-radio-group>
                    </div>
                  </div>
                  <div class="col-12 mt-sm-2 mt-md-0 mt-lg-2">
                    <p v-if="customer.BillDeliveryMethods.length == 0" class="font-weight-bold">
                      <b-badge variant="danger">WARNING</b-badge>
                      No bill delivery methods are set!
                    </p>
                  </div>
                  <!-- bill delivery method end -->
                  <!-- collection method start -->
                  <div class="row mt-4">
                    <div class="col-12">
                      <p class="font-weight-bold d-inline">Collection Methods</p>
                    </div>
                    <div class="col-12">
                      <b-form-radio-group v-model="pendingCollectionMethod" @change="onCollectionMethodAttempt">
                        <div class="row">
                          <div v-for="method in collectionMethods" :key="method.value" class="col-6 mb-2">
                            <b-form-radio :value="method.value">
                              {{ method.name }}
                            </b-form-radio>
                          </div>
                        </div>
                      </b-form-radio-group>
                    </div>
                  </div>
                  <!-- Hidden trigger for DDFIX modal -->
                  <button id="openDdfixModalBtn" type="button" class="d-none" data-toggle="modal"
                    data-target="#DdfixChangeModal"></button>
                  <!-- Modal for DDFIX change warning -->
                  <DdfixChangeModal @ok="confirmDdfixChange" @cancel="cancelDdfixChange" />
                  <!-- collection method end -->
                  <div id="allocationMethods" class="row mt-4" v-if="showAllocationMethods">
                    <div class="col-12">
                      <p class="font-weight-bold d-inline">Allocation Methods</p>
                    </div>
                  </div>
                  <div class="row" v-if="showAllocationMethods">
                    <div class="col-6 col-sm-12 col-md-6">
                      <b-form-radio-group v-model="allocationMethod" @change="openModal">
                        <div class="row">
                          <div class="col">
                            <b-form-radio class="ml-2 mb-2" id="" value="Automatic" :disabled="account.HasAllocations">
                              Automatic
                              <span v-if="account.HasAllocations" class="ml-1">
                                <span>
                                  <i id="popover-allocationMethods" class="fas fa-info-circle pointer"
                                    aria-hidden="true"></i>
                                  <b-popover target="popover-allocationMethods" triggers="hover focus click">
                                    <span>The allocation method for this account can't be changed, because there are
                                      existing manual allocations. Please, <a
                                        :class="supportDeskUrl ? 'underline' : ''" :href="supportDeskUrl ? supportDeskUrl : null"
                                        target="_blank">contact support</a> if you require assistance.
                                    </span>
                                  </b-popover>
                                </span>
                              </span>
                            </b-form-radio>
                          </div>
                          <div class="col">
                            <b-form-radio class="ml-2 mb-2" id="" value="Manual">Manual</b-form-radio>
                          </div>
                        </div>
                      </b-form-radio-group>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <DdfixChangeModal />
  </div>
</template>

<script>
import DdfixChangeModal from '@/components/modals/DdfixChangeModal.vue';
import snotifyHttpError from '@/mixins/snotifyHttpResponses';

export default {
  components: { DdfixChangeModal },
  mixins: [snotifyHttpError],
  data() {
    return {
      pendingCollectionMethod: null,
      collectionMethodTooltip: '',
      ddfixTargetMethod: null,
    };
  },
  computed: {
    customer: {
      get() {
        return this.$store.state.customers.customer;
      },
      set(customer) {
        this.$store.commit('updateCustomer', customer);
      },
    },
    account: {
      get() {
        return this.$store.state.customers.account;
      },
      set(account) {
        this.$store.commit('updateAccount', account);
      },
    },
    fallbackImage() {
      return this.$store.state.customers.fallbackImage;
    },
    billDeliveryMethod: {
      get() {
        if (!this.customer) return;
        if (!this.customer.BillDeliveryMethods) return;
        if (!this.customer.BillDeliveryMethods.length) return;
        return this.customer.BillDeliveryMethods[0];
      },
      set(deliveryMethod) {
        this.customer.BillDeliveryMethods = [deliveryMethod];
        this.updateBillDeliveryMethods();
      },
    },
    collectionMethods() {
      return this.$config.honeycomb.collectionMethods;
    },
    allocationMethod: {
      get() {
        if (!this.customer || !this.account) return;
        return this.account.AllocationMethod;
      },
      set(AllocationMethod) {
        this.account = { ...this.account, AllocationMethod };
        $('#AllocationMethodUpdate').attr(
          'data-allocation-method',
          AllocationMethod
        );
      },
    },
    showAllocationMethods() {
      return this.$config.honeycomb.allocationMethods;
    },
    isInDdfix() {
      return this.account && this.account.CollectionMethod === 'DDFIX';
    },
    supportDeskUrl() {
      return this.$config.honeycomb.supportDeskUrl
    }
  },
  watch: {
    'account.CollectionMethod': {
      immediate: true,
      handler(val) {
        this.pendingCollectionMethod = val;
      },
    },
  },

  mounted() {
    $('#AllocationMethodUpdate').on('hidden.bs.modal', () => {
      this.$store.dispatch('getAccount', this.$store.state.customers.customer);
    });
  },
  methods: {
    openModal() {
      $('#AllocationMethodUpdate').modal('show');
    },
    updateBillDeliveryMethods() {
      this.$snotify.async(
        'Updating bill delivery methods.',
        async () =>
          await new Promise((resolve, reject) => {
            if (this.customer.BillDeliveryMethods.length !== 1)
              reject({
                body: 'Failed! Bill delivery method required!',
                config: {
                  closeOnClick: false,
                  timeout: 0,
                },
              });
            else
              this.$http
                .put(
                  'https://' +
                  this.$config.honeycomb.contractbot.domain +
                  '/api/v1/Customers/' +
                  this.customer.Id,
                  this.customer,
                  {
                    withCredentials: true,
                  }
                )
                .then((response) => {
                  this.customer = response.data;
                  resolve({
                    body: 'Success! Bill delivery methods updated!',
                    config: {
                      closeOnClick: true,
                      timeout: 2000,
                    },
                  });
                })
                .catch((error) => {
                  this.$store.dispatch('refreshCustomerData');
                  reject(this.snotifyHttpError(error));
                });
          })
      );
    },
    onCollectionMethodAttempt(value) {
      if (this.isSEBL && this.isInDdfix && value !== 'DDFIX') {
        this.ddfixTargetMethod = value;
        this.pendingCollectionMethod = this.account.CollectionMethod;
        $('#DdfixChangeModal').modal('show');
        return;
      }
      this.changeCollectionMethod(value);
    },
    confirmDdfixChange() {
      if (this.ddfixTargetMethod) {
        this.changeCollectionMethod(this.ddfixTargetMethod);
        this.pendingCollectionMethod = this.ddfixTargetMethod;
        this.ddfixTargetMethod = null;
      }
    },
    cancelDdfixChange() {
      this.ddfixTargetMethod = null;
      this.pendingCollectionMethod = this.account.CollectionMethod;
    },
    changeCollectionMethod(value) {
      if (this.account.CollectionMethod === value) return;
      const updatedAccount = { ...this.account, CollectionMethod: value };
      this.$snotify.async(
        'Updating Collection Method.',
        async () =>
          new Promise((resolve, reject) => {
            this.$http
              .put(
                'https://' +
                this.$config.honeycomb.moneybot.domain +
                '/api/v1/Accounts/' +
                this.account.Id,
                updatedAccount,
                { withCredentials: true }
              )
              .then((response) => {
                this.account = response.data;
                this.pendingCollectionMethod = response.data.CollectionMethod;
                resolve({
                  body: 'Success! Collection method updated!',
                  config: { closeOnClick: true, timeout: 2000 },
                });
              })
              .then(() => this.$store.dispatch('refreshCustomerData'))
              .catch((error) => {
                this.$store.dispatch('refreshCustomerData');
                reject(this.snotifyHttpError(error));
              });
          })
      );
    },
    setFallbackImageUrl() {
      this.$store.commit('updateFallbackImage', true);
    },
    onCopy(e, elementId) {
      this.$snotify.success(`${e.text} copied to clipboard.`);
      document.getElementById(elementId).click();
    },
    onError() {
      this.$snotify.error(`Failed to copy text to clipboard.`, {
        timeout: 0,
        closeOnClick: true,
      });
    },
    formatTelephoneNumber(number) {
      if (number === null || number === undefined) return number;

      // Taken from: https://www.area-codes.org.uk/formatting.php
      let formats = [
        {
          id: 1,
          pattern: /^01[0-9]{8}$/,
          grouping: [5, 5],
        },
        {
          id: 2,
          pattern: /^01[0-9]{9}$/,
          grouping: [5, 6],
        },
        {
          id: 3,
          pattern: /^011[0-9]{8}$/,
          grouping: [4, 3, 4],
        },
        {
          id: 4,
          pattern: /^01[0-9]1[0-9]{7}$/,
          grouping: [4, 3, 4],
        },
        {
          id: 5,
          pattern: /^013397[0-9]{5}$/,
          grouping: [6, 5],
        },
        {
          id: 6,
          pattern: /^013398[0-9]{5}$/,
          grouping: [6, 5],
        },
        {
          id: 7,
          pattern: /^013873[0-9]{5}$/,
          grouping: [6, 5],
        },
        {
          id: 8,
          pattern: /^015242[0-9]{5}$/,
          grouping: [6, 5],
        },
        {
          id: 9,
          pattern: /^015394[0-9]{5}$/,
          grouping: [6, 5],
        },
        {
          id: 10,
          pattern: /^015395[0-9]{5}$/,
          grouping: [6, 5],
        },
        {
          id: 11,
          pattern: /^015395[0-9]{5}$/,
          grouping: [6, 5],
        },
        {
          id: 12,
          pattern: /^015396[0-9]{5}$/,
          grouping: [6, 5],
        },
        {
          id: 13,
          pattern: /^016973[0-9]{5}$/,
          grouping: [6, 5],
        },
        {
          id: 14,
          pattern: /^016974[0-9]{5}$/,
          grouping: [6, 5],
        },
        {
          id: 15,
          pattern: /^016977[0-9]{4}$/,
          grouping: [6, 4],
        },
        {
          id: 16,
          pattern: /^016977[0-9]{5}$/,
          grouping: [6, 5],
        },
        {
          id: 17,
          pattern: /^017683[0-9]{5}$/,
          grouping: [6, 5],
        },
        {
          id: 18,
          pattern: /^017684[0-9]{5}$/,
          grouping: [6, 5],
        },
        {
          id: 19,
          pattern: /^017687[0-9]{5}$/,
          grouping: [6, 5],
        },
        {
          id: 20,
          pattern: /^019467[0-9]{5}$/,
          grouping: [6, 5],
        },
        {
          id: 21,
          pattern: /^019755[0-9]{5}$/,
          grouping: [6, 5],
        },
        {
          id: 22,
          pattern: /^019756[0-9]{5}$/,
          grouping: [6, 5],
        },
        {
          id: 23,
          pattern: /^02[0-9]{9}$/,
          grouping: [3, 4, 4],
        },
        {
          id: 24,
          pattern: /^03[0-9]{9}$/,
          grouping: [4, 3, 4],
        },
        {
          id: 25,
          pattern: /^05[0-9]{9}$/,
          grouping: [5, 6],
        },
        {
          id: 26,
          pattern: /^07[0-9]{9}$/,
          grouping: [5, 6],
        },
        {
          id: 27,
          pattern: /^0800[0-9]{6}$/,
          grouping: [4, 6],
        },
        {
          id: 28,
          pattern: /^08[0-9]{9}$/,
          grouping: [4, 3, 4],
        },
        {
          id: 29,
          pattern: /^09[0-9]{9}$/,
          grouping: [4, 3, 4],
        },
        {
          id: 30,
          pattern: /^08001111$/,
          grouping: [4, 4],
        },
        {
          id: 31,
          pattern: /^08454647$/,
          grouping: [4, 4],
        },
      ];

      // Remove whitespace
      var temp = number.replace(/\s/g, '');

      let format = null;

      // Get the last format that matches
      formats.forEach(function (f) {
        var result = temp.match(f.pattern);

        if (result != null) format = f;
      });

      // If none match, return the input.
      if (format == null) return number;

      // Format the number
      let output = '';
      let index = 0;

      format.grouping.forEach(function (length) {
        output += temp.substr(index, length) + ' ';
        index += length;
      });

      return output.trim();
    },
  },
};
</script>
